<template>
<div class="badge text-white" :class="variant">
    {{ status }}
</div>
</template>

<script>
import Vue from 'vue'
import { userStatusStr, userStatus, userVariant } from '@/constants/userStatus'
export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        status() {
            return userStatusStr.get(this.row.status)
        },
        variant() {
            return 'badge-'+userVariant(this.row.status)
        }
    }
})
</script>

<style>

</style>